import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import {
  ISectorBreakDownOverviewResponse,
  ISectorProjectionDataResponse,
  ISectorProjectionLflNriResponse,
  ISectorProjectionResponse,
} from '../../interfaces';
import {
  autoDestroy,
  extractQueryRegionIds,
  followDestroy,
} from '@kolytics/shared-functions';
import { map, switchMap, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { ClientStoreService } from '../../../../store/client.store.service';
import { Meta, Title } from '@angular/platform-browser';
import { SectorRegionService } from '../../services/sector-region.service';
import { SectorsProjectionsRiskReturnComponent } from './sectors-projections-risk-return/sectors-projections-risk-return.component';
import { SectorsProjectionsBalanceSheetStrengthComponent } from './sectors-projections-balance-sheet-strength/sectors-projections-balance-sheet-strength.component';
import { SectorsProjectionsCostAnalysisComponent } from './sectors-projections-cost-analysis/sectors-projections-cost-analysis.component';
import { SectorsProjectionsLflNriComponent } from './sectors-projections-lfl-nri/sectors-projections-lfl-nri.component';
import { SectorsProjectionsOccupancyLevelsComponent } from './sectors-projections-occupancy-levels/sectors-projections-occupancy-levels.component';
import { SeparatorComponent } from '../../../../../../../../libs/shared-components/src/lib/components/separator/separator.component';
import { SectorsProjectionsMarketRateGrowthComponent } from './sectors-projections-market-rate-growth/sectors-projections-market-rate-growth.component';
import { ButtonComponent } from '../../../../../../../../libs/shared-components/src/lib/components/common/button/button.component';
import { ReitService, SectorService } from '@kolytics/shared-api';

@Component({
  selector: 'klt-sectors-projections',
  templateUrl: './sectors-projections.component.html',
  styleUrls: ['./sectors-projections.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ButtonComponent,
    SectorsProjectionsMarketRateGrowthComponent,
    SeparatorComponent,
    SectorsProjectionsOccupancyLevelsComponent,
    SectorsProjectionsLflNriComponent,
    SectorsProjectionsCostAnalysisComponent,
    SectorsProjectionsBalanceSheetStrengthComponent,
    SectorsProjectionsRiskReturnComponent,
  ],
})
@autoDestroy()
export class SectorsProjectionsComponent implements OnInit {
  sectorName!: string;
  sectors!: ISectorProjectionResponse;
  loader: boolean = true;
  sectorId!: string;

  constructor(
    protected readonly activatedRoute: ActivatedRoute,
    protected readonly service: ReitService,
    private clientStoreService: ClientStoreService,
    public meta: Meta,
    public title: Title,
    private cdr: ChangeDetectorRef,
    private sectorRegionService: SectorRegionService,
    private sectorService: SectorService,
  ) {}

  ngOnInit() {
    const regionIds = extractQueryRegionIds(
      this.activatedRoute.snapshot.queryParams,
    );

    this.activatedRoute.parent?.params
      .pipe(
        map((params) => params.id),
        switchMap((id) => {
          this.sectorId = id;
          return this.sectorService.apiSectorDataSectorIdProjectionGet(
            id,
            regionIds,
          );
        }),
        tap(({ sectors }) => {
          this.sectorName = sectors.sectorName;
        }),
        followDestroy(this),
      )
      .subscribe((data) => {
        // setTimeout (() => {
        this.sectorName = data.sectors.sectorName;
        this.title.setTitle(`Kolytics | ${data.sectors.sectorName} sector`);
        this.sectors = data;
        this.cdr.detectChanges();
        // }, 1000);}
        // );
      });
  }

  public openRegionFilter(): void {
    this.sectorRegionService.openRegionFilter(Number(this.sectorId), () => {
      this.sectorService
        .apiSectorDataSectorIdProjectionGet(
          Number(this.sectorId),
          this.sectorRegionService.regionsIds,
        )
        .subscribe((data) => {
          this.sectorName = data.sectors.sectorName;
          this.title.setTitle(`Kolytics | ${data.sectors.sectorName} sector`);
          this.sectors = data;
          this.cdr.detectChanges();
        });
    });
  }
}
